<template>
   <h3 style="display:none">meta - tags - definition</h3>
  </template>
  <script>
  import { mapGetters } from "vuex";
  
  export default {
    name: "metaTags",
  
    data: () => ({
    }),
    
    watch: {
      "dadosEmpresa"(){
        this.defineMetaTags()
        this.setMetaTags()
      }
    },
  
    computed: {
      ...mapGetters([
        "selecionadoCategorias",
        "database",
        "dadosEmpresa",
        "carrinho",
        "pedidos",
        "produtos",
        "categorias",
        "horario",
        "busca",
        "disableDelivery",
        "disableEncomenda",
        "combos",
        "shownAlert",
        "bairros",
      ]),
    },
    methods: {
        defineMetaTags(){
      let ogTitleTag = document.querySelector('meta[property="og:title"]');
      let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
      let ogImageTag = document.querySelector('meta[property="og:image"]');
      let descriptionTag = document.querySelector('meta[name="description"]'); // Select the standard description meta tag

      // Check if the meta tags exist; if not, create and append them to the document's head
      if (!ogTitleTag) {
        ogTitleTag = document.createElement('meta');
        ogTitleTag.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitleTag);
      } 
      if (!ogDescriptionTag) {
        ogDescriptionTag = document.createElement('meta');
        ogDescriptionTag.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescriptionTag);
      }

      if (!ogImageTag) {
        ogImageTag = document.createElement('meta');
        ogImageTag.setAttribute('property', 'og:image');
        document.head.appendChild(ogImageTag);
      }

      if (!descriptionTag) {
        descriptionTag = document.createElement('meta');
        descriptionTag.setAttribute('name', 'description'); // Set the name attribute for the standard description
        document.head.appendChild(descriptionTag);
      }
    },
    setMetaTags(){
      let ogTitleTag = document.querySelector('meta[property="og:title"]');
      let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
      let ogImageTag = document.querySelector('meta[property="og:image"]');
      let descriptionTag = document.querySelector('meta[name="description"]');

      ogTitleTag.setAttribute('content', this.dadosEmpresa.nome + ' | Delivery Ibo-Solutions');
      ogDescriptionTag.setAttribute('content', this.dadosEmpresa.nome + ' | Delivery Ibo-Solutions');
      ogImageTag.setAttribute('content', this.dadosEmpresa.img_url);
      document.title = this.dadosEmpresa.nome
      descriptionTag.setAttribute('content', this.dadosEmpresa.nome + ' | Delivery Ibo-Solutions');

    }
    },
  
    async created() {
        let interval = setInterval(() => {
        if(document.title == this.dadosEmpresa.nome){
            clearInterval(interval)
            this.$router.push("/")
        }
        }, 4000);
        
    },
    mounted() {},
    activated() {
      
    },
  };
  </script>
  <style lang="scss" scoped>

  </style>
  